import React from 'react';
import styles from './FormInput.module.css'; // Reuse input styles for consistency

const FormFieldGroup = ({
    label,
    children,
    error,
    required = false,
    hint,
    className = '',
    style = {}
}) => {
    return (
        <div className={`${styles.container} ${className}`} style={style}>
            {label && (
                <label className={styles.label}>
                    {label}
                    {required && <span className={styles.required}>*</span>}
                </label>
            )}

            <div className={styles.inputWrapper}>
                {children}
            </div>

            {hint && !error && (
                <div className={styles.hint} style={{ fontSize: '0.8rem', color: 'var(--color-text-tertiary)', marginTop: '4px' }}>
                    {hint}
                </div>
            )}

            {error && (
                <div className={styles.error} role="alert">
                    {error}
                </div>
            )}
        </div>
    );
};

export { FormFieldGroup };
export default FormFieldGroup;
